<template>
    <md-card style="margin-top: 40px;">
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
                <font-awesome-icon class="md-icon" :icon="['fa', 'clock']"/>
            </div>
            <h4 class="title">Historique</h4>
        </md-card-header>
        <md-card-content>
			<log v-for="log in logs" :key="log.id"
				 :date="log.created_at"
				 :message="log.message"
				 :author="log.user"></log>
        </md-card-content>
    </md-card>
</template>

<script>
import Log from '/src/components/Logs/Log'
export default {
    name: "History",
	components: {
		Log
	},
    props : {
        logs: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
